(function () {
  'use strict';

  var CARD = '[data-atlekx-card]';
  var QUICK_BTN = '.quick-product__btn';
  var states = new WeakMap();

  function parseVariants(card) {
    var node = card.querySelector('[data-atlekx-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function getIndex(card, attr) {
    var raw = card.getAttribute(attr);
    if (raw === null || raw === '') return -1;
    var n = parseInt(raw, 10);
    return isNaN(n) ? -1 : n;
  }

  function cardHost(card) {
    return card.closest('.grid-product') || card.parentElement;
  }

  function findCardImage(card) {
    var host = cardHost(card);
    if (!host) return null;
    return host.querySelector('.grid__item-image-wrapper img');
  }

  function swapImage(card, src) {
    if (!src) return;
    var img = findCardImage(card);
    if (!img) return;
    if (img.getAttribute('data-atlekx-saved') !== 'true') {
      img.setAttribute('data-atlekx-saved', 'true');
      img.setAttribute('data-atlekx-src', img.getAttribute('src') || '');
      img.setAttribute('data-atlekx-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-atlekx-sizes', img.getAttribute('sizes') || '');
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
  }

  function matchingVariants(variants, colorIndex, color) {
    if (colorIndex < 0 || !color) return variants;
    return variants.filter(function (v) {
      return v.opts[colorIndex] === color;
    });
  }

  function resolveVariant(state) {
    var pool = matchingVariants(state.variants, state.colorIndex, state.color);
    if (state.sizeIndex < 0) {
      var firstAvailable = pool.filter(function (v) {
        return v.av;
      })[0];
      return firstAvailable || pool[0] || null;
    }
    if (!state.size) return null;
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].opts[state.sizeIndex] === state.size) return pool[i];
    }
    return null;
  }

  function refreshSizes(card, state) {
    var buttons = card.querySelectorAll('[data-atlekx-size]');
    if (!buttons.length) return;
    var pool = matchingVariants(state.variants, state.colorIndex, state.color);

    Array.prototype.forEach.call(buttons, function (btn) {
      var value = btn.getAttribute('data-atlekx-size');
      var available = pool.some(function (v) {
        return v.opts[state.sizeIndex] === value && v.av;
      });
      btn.classList.toggle('is-unavailable', !available);
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (!available && state.size === value) {
        state.size = null;
        btn.classList.remove('is-active');
      }
    });
  }

  function labelFor(state) {
    if (state.variantId) return state.labelDefault;
    if (state.sizeIndex >= 0 && !state.size) return state.labelPickSize;
    return state.labelSoldOut;
  }

  function coversAllOptions(state) {
    var controlled = 0;
    if (state.colorIndex >= 0) controlled++;
    if (state.sizeIndex >= 0) controlled++;
    return state.totalOptions > 0 && controlled >= state.totalOptions;
  }

  function canAdd(state) {
    if (!state.touched) return false;
    if (!coversAllOptions(state)) return false;
    if (!state.variantId) return false;
    if (state.sizeIndex >= 0 && !state.size) return false;
    return true;
  }

  function refreshButton(card, state) {
    var variant = resolveVariant(state);
    state.variantId = variant && variant.av ? variant.id : null;

    var own = card.querySelector('[data-atlekx-atc]');
    if (own && own.getAttribute('data-atlekx-state') === null) {
      own.disabled = !state.variantId;
      own.textContent = labelFor(state);
    }

    if (state.quickHook) {
      var quick = quickButtonFor(card);
      if (quick && quick.getAttribute('data-atlekx-state') === null) {
        if (canAdd(state)) {
          quick.textContent = state.labelDefault;
          quick.setAttribute('data-atlekx-ready', 'true');
          quick.removeAttribute('aria-expanded');
        } else {
          quick.textContent = state.labelQuick;
          quick.removeAttribute('data-atlekx-ready');
          if (quick.classList.contains('js-modal-open-quick-modal-' + card.getAttribute('data-product-id'))) {
            quick.setAttribute('aria-expanded', 'false');
          }
        }
      }
    }
  }

  function quickButtonFor(card) {
    var host = cardHost(card);
    return host ? host.querySelector(QUICK_BTN) : null;
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/add.js';
  }

  function refreshCartCount() {
    var hasDrawer = window.theme && theme.settings && theme.settings.cartType === 'drawer';
    if (hasDrawer) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble-num'), function (el) {
          el.textContent = cart.item_count;
        });
        Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble'), function (el) {
          el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  function addToCart(card, state, btn) {
    if (!state.variantId || !btn) return;

    var restore = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('data-atlekx-state', 'loading');
    btn.textContent = state.labelAdding;

    fetch(cartUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function () {
        btn.setAttribute('data-atlekx-state', 'added');
        btn.textContent = state.labelAdded;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        refreshCartCount();
        window.setTimeout(function () {
          btn.removeAttribute('data-atlekx-state');
          btn.disabled = false;
          btn.textContent = restore;
          refreshButton(card, state);
        }, 1800);
      })
      .catch(function () {
        btn.setAttribute('data-atlekx-state', 'error');
        btn.textContent = state.labelError;
        window.setTimeout(function () {
          btn.removeAttribute('data-atlekx-state');
          btn.disabled = false;
          btn.textContent = restore;
          refreshButton(card, state);
        }, 2200);
      });
  }

  function initCard(card) {
    if (card.getAttribute('data-atlekx-ready') === 'true') return;
    card.setAttribute('data-atlekx-ready', 'true');

    var state = {
      variants: parseVariants(card),
      colorIndex: getIndex(card, 'data-color-index'),
      sizeIndex: getIndex(card, 'data-size-index'),
      color: card.getAttribute('data-initial-color') || null,
      totalOptions: parseInt(card.getAttribute('data-total-options'), 10) || 0,
      touched: false,
      size: null,
      variantId: null,
      quickHook: card.getAttribute('data-quickshop-hook') === 'true',
      labelDefault: card.getAttribute('data-label-add') || 'Agregar',
      labelPickSize: card.getAttribute('data-label-pick') || 'Elige una talla',
      labelSoldOut: card.getAttribute('data-label-soldout') || 'Agotado',
      labelAdding: card.getAttribute('data-label-adding') || 'Agregando...',
      labelAdded: card.getAttribute('data-label-added') || 'Agregado',
      labelError: card.getAttribute('data-label-error') || 'Intenta de nuevo',
      labelQuick: card.getAttribute('data-label-quick') || 'Compra rapida'
    };

    if (!state.variants.length) return;
    states.set(card, state);

    var fallbackBtn = card.querySelector('[data-atlekx-fallback]');
    if (fallbackBtn) {
      if (state.quickHook && quickButtonFor(card)) {
        fallbackBtn.remove();
      } else {
        fallbackBtn.removeAttribute('hidden');
        fallbackBtn.removeAttribute('data-atlekx-fallback');
        state.quickHook = false;
      }
    }

    card.addEventListener('click', function (event) {
      var moreBtn = event.target.closest('[data-atlekx-more]');
      if (moreBtn && card.contains(moreBtn)) {
        event.preventDefault();
        event.stopPropagation();
        Array.prototype.forEach.call(card.querySelectorAll('.atlekx-card__color--extra'), function (b) {
          b.removeAttribute('hidden');
          b.classList.remove('atlekx-card__color--extra');
        });
        moreBtn.setAttribute('aria-expanded', 'true');
        moreBtn.remove();
        return;
      }

      var colorBtn = event.target.closest('[data-atlekx-color]');
      if (colorBtn && card.contains(colorBtn)) {
        event.preventDefault();
        event.stopPropagation();
        state.touched = true;
        state.color = colorBtn.getAttribute('data-atlekx-color');
        Array.prototype.forEach.call(card.querySelectorAll('[data-atlekx-color]'), function (b) {
          b.classList.toggle('is-active', b === colorBtn);
        });
        swapImage(card, colorBtn.getAttribute('data-atlekx-image'));
        refreshSizes(card, state);
        refreshButton(card, state);
        return;
      }

      var sizeBtn = event.target.closest('[data-atlekx-size]');
      if (sizeBtn && card.contains(sizeBtn)) {
        event.preventDefault();
        event.stopPropagation();
        if (sizeBtn.classList.contains('is-unavailable')) return;
        state.touched = true;
        state.size = sizeBtn.getAttribute('data-atlekx-size');
        Array.prototype.forEach.call(card.querySelectorAll('[data-atlekx-size]'), function (b) {
          b.classList.toggle('is-active', b === sizeBtn);
        });
        refreshButton(card, state);
        return;
      }

      var atcBtn = event.target.closest('[data-atlekx-atc]');
      if (atcBtn && card.contains(atcBtn)) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(card, state, atcBtn);
      }
    });

    refreshSizes(card, state);
    refreshButton(card, state);
  }

  document.addEventListener(
    'click',
    function (event) {
      var quick = event.target.closest(QUICK_BTN);
      if (!quick) return;

      var fallbackUrl = quick.getAttribute('data-atlekx-quickview-url');

      var host = quick.closest('.grid-product');
      if (!host) {
        if (fallbackUrl) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = fallbackUrl;
        }
        return;
      }

      var card = host.querySelector(CARD);
      if (!card) return;

      var state = states.get(card);

      if ((!state || !state.quickHook || !canAdd(state)) && fallbackUrl) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        window.location.href = fallbackUrl;
        return;
      }

      if (!state || !state.quickHook) return;

      if (!canAdd(state)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addToCart(card, state, quick);
    },
    true
  );

  /* ------------------------------------------------------------------
     Vista rapida ("LO QUIERO")
     - El modal se precarga cuando la tarjeta entra en pantalla (escritorio),
       asi que al pasar el cursor normalmente ya esta listo.
     - Una sola peticion por producto aunque se pase el cursor varias veces.
     - Si se hace clic antes de que este listo, el boton muestra un spinner
       y el modal se abre solo en cuanto termina de cargar.
     ------------------------------------------------------------------ */
  var quickJobs = {};
  var quickQueue = [];
  var quickActive = 0;
  var quickObserver = null;
  var QUICK_MAX_PARALLEL = 2;

  function quickViewUrl(handle) {
    var root = (window.theme && theme.routes && theme.routes.home) || '';
    return (root + '/products/' + handle).replace('//', '/');
  }

  function quickButtonsFor(productId) {
    return document.querySelectorAll('.js-modal-open-quick-modal-' + productId);
  }

  function preloadQuickView(handle, productId) {
    var holder = handle ? document.getElementById('QuickShopHolder-' + handle) : null;
    if (!holder) return Promise.resolve(false);
    if (holder.getAttribute('data-atlekx-quickview') === 'ready') return Promise.resolve(true);
    if (quickJobs[handle]) return quickJobs[handle];

    var job = fetch(quickViewUrl(handle) + '?view=modal', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;

        var node =
          html.querySelector('.product-section[data-product-handle="' + handle + '"]') ||
          html.querySelector('.product-section') ||
          html.querySelector('[data-section-type="product"]');

        if (!node) throw new Error('sin product-section');

        holder.innerHTML = '';
        holder.appendChild(node);

        try {
          new theme.Modals('QuickShopModal-' + productId, 'quick-modal-' + productId);
        } catch (e) {}
        try {
          theme.sections.register('product', theme.Product, holder);
        } catch (e) {}
        try {
          theme.collapsibles.init();
        } catch (e) {}
        try {
          theme.videoModal();
        } catch (e) {}

        holder.setAttribute('data-atlekx-quickview', 'ready');
        return true;
      })
      .catch(function () {
        delete quickJobs[handle];
        holder.setAttribute('data-atlekx-quickview', 'failed');
        Array.prototype.forEach.call(quickButtonsFor(productId), function (btn) {
          btn.classList.remove('btn--not-ready');
          btn.setAttribute('data-atlekx-quickview-url', quickViewUrl(handle));
        });
        return false;
      });

    quickJobs[handle] = job;
    return job;
  }

  function patchThemeQuickView() {
    if (!window.theme || typeof theme.preloadProductModal !== 'function') return;
    if (theme.preloadProductModal.atlekxPatched) return;

    var patched = function (handle, productId) {
      return preloadQuickView(handle, productId);
    };
    patched.atlekxPatched = true;
    theme.preloadProductModal = patched;
  }

  function quickViewDesktop() {
    if (!window.theme || !theme.settings || !theme.settings.quickView) return false;
    if (theme.config && theme.config.isTouch) return false;
    if (!window.matchMedia) return true;
    if (window.matchMedia('(max-width: 768px)').matches) return false;
    if (!window.matchMedia('(hover: hover)').matches) return false;
    return true;
  }

  function pumpQuickQueue() {
    while (quickActive < QUICK_MAX_PARALLEL && quickQueue.length) {
      var host = quickQueue.shift();
      if (!document.contains(host)) continue;
      quickActive++;
      preloadQuickView(host.getAttribute('data-product-handle'), host.getAttribute('data-product-id')).then(quickDone, quickDone);
    }
  }

  function quickDone() {
    quickActive = Math.max(0, quickActive - 1);
    pumpQuickQueue();
  }

  function observeQuickCards(scope) {
    if (!quickViewDesktop() || !('IntersectionObserver' in window)) return;

    if (!quickObserver) {
      quickObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            quickObserver.unobserve(entry.target);
            quickQueue.push(entry.target);
          });
          pumpQuickQueue();
        },
        { rootMargin: '160px 0px' }
      );
    }

    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('.grid-product[data-product-handle]'), function (host) {
      if (host.getAttribute('data-atlekx-qv') === 'observed') return;
      if (!host.querySelector(QUICK_BTN)) return;
      if (host.closest('.product-recommendations-placeholder')) return;
      host.setAttribute('data-atlekx-qv', 'observed');
      quickObserver.observe(host);
    });
  }

  // Clic en "LO QUIERO" antes de que el modal este listo: spinner y apertura automatica
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest(QUICK_BTN);
      if (!btn || !btn.classList.contains('btn--not-ready')) return;
      if (btn.getAttribute('data-atlekx-quickview-url')) return;

      var host = btn.closest('.grid-product');
      if (!host) return;

      var handle = host.getAttribute('data-product-handle');
      var productId = host.getAttribute('data-product-id');
      if (!handle || !productId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (btn.getAttribute('data-atlekx-waiting') === 'true') return;
      btn.setAttribute('data-atlekx-waiting', 'true');
      btn.classList.add('btn--loading');

      preloadQuickView(handle, productId).then(function (ok) {
        btn.classList.remove('btn--loading');
        btn.removeAttribute('data-atlekx-waiting');
        if (ok && !btn.classList.contains('btn--not-ready')) {
          btn.click();
        } else if (!ok) {
          window.location.href = quickViewUrl(handle);
        }
      });
    },
    true
  );

  /* ------------------------------------------------------------------
     Galeria de producto: salto directo a la imagen de la variante
     Al elegir un color, el tema desplazaba el carrusel pasando por todas
     las imagenes intermedias. Ahora hace un fundido corto y aparece la
     imagen de la variante directamente (ficha de producto y vista rapida).
     ------------------------------------------------------------------ */
  var FADE_OUT_MS = 130;
  var FADE_IN_MS = 190;
  var lastVariantChange = 0;

  document.addEventListener('variant:change', function () {
    lastVariantChange = Date.now();
  });

  function variantJumpPending() {
    return Date.now() - lastVariantChange < 200;
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function crossfadeTo(flkty, index) {
    if (!flkty || typeof flkty.select !== 'function') return;
    if (flkty.selectedIndex === index && !flkty.element.atlekxSwapTimer) return;

    var el = flkty.element;
    var viewport = flkty.viewport || el.querySelector('.flickity-viewport');

    if (!viewport || reducedMotion()) {
      flkty.select(index, false, true);
      return;
    }

    if (el.atlekxSwapTimer) window.clearTimeout(el.atlekxSwapTimer);

    viewport.style.transition = 'opacity ' + FADE_OUT_MS + 'ms ease, height 0.2s';
    viewport.style.opacity = '0';

    el.atlekxSwapTimer = window.setTimeout(function () {
      flkty.select(index, false, true);
      window.requestAnimationFrame(function () {
        viewport.style.transition = 'opacity ' + FADE_IN_MS + 'ms ease, height 0.2s';
        viewport.style.opacity = '1';
        el.atlekxSwapTimer = window.setTimeout(function () {
          viewport.style.transition = '';
          viewport.style.opacity = '';
          el.atlekxSwapTimer = null;
        }, FADE_IN_MS + 20);
      });
    }, FADE_OUT_MS);
  }

  function patchSlideshowVariantJump() {
    if (!window.theme || !theme.Slideshow || !theme.Slideshow.prototype) return;
    var proto = theme.Slideshow.prototype;
    if (proto.atlekxJumpPatched) return;

    var original = proto.goToSlide;
    if (typeof original !== 'function') return;

    proto.goToSlide = function (mediaIdOrIndex) {
      var slideshow = this.slideshow;
      if (!slideshow || !variantJumpPending()) return original.apply(this, arguments);

      var id = String(mediaIdOrIndex);
      var index = -1;
      for (var c = 0; slideshow.cells && c < slideshow.cells.length; c++) {
        if (slideshow.cells[c].element.dataset.mediaId === id) {
          index = c;
          break;
        }
      }
      if (index < 0) index = parseInt(mediaIdOrIndex, 10) || 0;

      crossfadeTo(slideshow, index);
    };

    proto.atlekxJumpPatched = true;
  }

  /* ------------------------------------------------------------------
     Vista rapida: la galeria sigue a la variante elegida
     Dentro del modal, al cambiar de color (o cualquier opcion) se busca
     la imagen de la variante y se muestra en el carrusel, igual que en
     la ficha de producto.
     ------------------------------------------------------------------ */
  var modalVariantCache = new WeakMap();

  function modalVariants(section) {
    if (modalVariantCache.has(section)) return modalVariantCache.get(section);
    var list = [];
    var json = section.querySelector('[data-variant-json]');
    if (json) {
      try {
        list = JSON.parse(json.textContent) || [];
      } catch (e) {
        list = [];
      }
    }
    modalVariantCache.set(section, list);
    return list;
  }

  function showVariantMedia(section, variantId) {
    var variants = modalVariants(section);
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) {
        variant = variants[i];
        break;
      }
    }
    if (!variant || !variant.featured_media) return;

    var gallery = section.querySelector('[data-product-photos]');
    if (!gallery) return;

    var slide = gallery.querySelector('.product-main-slide[data-media-id="' + variant.featured_media.id + '"]');
    if (!slide) return;

    var flkty = window.Flickity && typeof Flickity.data === 'function' ? Flickity.data(gallery) : null;
    if (flkty && typeof flkty.select === 'function') {
      // Si el tema ya esta haciendo el salto, no se repite
      if (gallery.atlekxSwapTimer) return;
      var cells = typeof flkty.getCellElements === 'function' ? flkty.getCellElements() : [];
      var index = cells.indexOf(slide);
      if (index < 0) index = parseInt(slide.getAttribute('data-index'), 10);
      if (!isNaN(index) && index >= 0) crossfadeTo(flkty, index);
      return;
    }

    // Sin carrusel (una sola imagen o aun no inicializado): marcar la diapositiva
    Array.prototype.forEach.call(gallery.querySelectorAll('.product-main-slide'), function (el) {
      el.classList.toggle('is-selected', el === slide);
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-variant-input]')) return;

    var section = input.closest('.product-section[data-modal="true"]');
    if (!section) return;

    // theme.js actualiza el select maestro en este mismo evento; se lee justo despues
    window.setTimeout(function () {
      var master = section.querySelector('[data-product-select]');
      if (!master || !master.value) return;
      showVariantMedia(section, master.value);
    }, 0);
  });

  /* ------------------------------------------------------------------
     Vista rapida: bloques ya pintados en la plantilla product.modal
     El tema espera un contenedor vacio ([data-blocks-holder]) y descarga
     el formulario al abrir el modal. Si la plantilla del modal ya trae
     bloques (precio, variantes, botones...), ese contenedor no existe y
     el tema se detiene antes de enlazar variantes, carrusel y carrito.
     Aqui se inicializa todo directamente, sin segunda peticion.
     ------------------------------------------------------------------ */
  function suffixModalIds(blocks) {
    Array.prototype.forEach.call(blocks.querySelectorAll('[id]'), function (el) {
      var id = el.getAttribute('id');
      if (!id || /-modal$/.test(id)) return;
      var next = id + '-modal';
      el.setAttribute('id', next);

      var label = blocks.querySelector('[for="' + id + '"]');
      if (label) label.setAttribute('for', next);

      var trigger = blocks.querySelector('[aria-controls="' + id + '"]');
      if (trigger) trigger.setAttribute('aria-controls', next);

      Array.prototype.forEach.call(blocks.querySelectorAll('[form="' + id + '"]'), function (field) {
        field.setAttribute('form', next);
      });
    });
  }

  function patchModalProduct() {
    if (!window.theme || !theme.Product || !theme.Product.prototype) return;
    var proto = theme.Product.prototype;
    if (proto.atlekxModalPatched) return;

    var original = proto.openModalProduct;
    if (typeof original !== 'function') return;

    proto.openModalProduct = function () {
      var holder = this.container.querySelector('[data-blocks-holder]');
      if (holder || this.settings.modalInit) {
        return original.apply(this, arguments);
      }

      var blocks = this.container.querySelector('[data-product-blocks]');
      if (!blocks) return;

      suffixModalIds(blocks);

      this.cacheElements();
      try { this.updateModalProductInventory(); } catch (e) {}
      try { this.formSetup(); } catch (e) {}
      if (window.Shopify && Shopify.PaymentButton) {
        try { Shopify.PaymentButton.init(); } catch (e) {}
      }
      try { theme.collapsibles.init(this.container); } catch (e) {}
      try { this.productSetup(); } catch (e) {}
      try { this.videoSetup(); } catch (e) {}
      try { this.initProductSlider(); } catch (e) {}
      try { this.customMediaListners(); } catch (e) {}
      try { this.addIdToRecentlyViewed(); } catch (e) {}

      this.settings.modalInit = true;

      document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { productId: this.productId } }));
      if (window.AOS) AOS.refreshHard();
      document.dispatchEvent(new CustomEvent('quickview:open', { detail: { initialized: false, productId: this.productId } }));
    };

    proto.atlekxModalPatched = true;
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(CARD), initCard);
  }

  function boot(scope) {
    patchThemeQuickView();
    patchModalProduct();
    patchSlideshowVariantJump();
    initAll(scope || document);
    observeQuickCards(scope || document);
  }

  // Los scripts "defer" corren antes de DOMContentLoaded y theme.js se carga
  // despues de este archivo, asi que esperamos a DOMContentLoaded para que
  // theme.preloadProductModal ya exista y se pueda reemplazar.
  if (document.readyState === 'complete') {
    boot(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
  document.addEventListener('collection:reloaded', function () {
    boot(document);
  });
  document.addEventListener('recommendations:loaded', function () {
    boot(document);
  });
})();
